'use client'

import { Flex, Menu, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import IconCheckmark from '@/assets/icons/checkmark.svg'
import IconChevronDown from '@/assets/icons/chevron-down.svg'

import styles from './style.module.css'

interface SortOption {
  readonly value: string
  readonly labelKey: string
}

interface SortMenuProps {
  options: readonly SortOption[]
  activeValue: string
  onChange: (value: string) => void
  /** 可选无障碍标签（沿用调用方原 Select 时期的 aria-label，如 Prediction 的 sortAria）。 */
  ariaLabel?: string
}

export default function SortMenu({
  options,
  activeValue,
  onChange,
  ariaLabel,
}: Readonly<SortMenuProps>) {
  const t = useTranslations()
  const [opened, setOpened] = useState(false)
  const activeOption = options.find(o => o.value === activeValue) ?? options[0]

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      classNames={{ dropdown: styles.sortMenuDropdown }}
      position="bottom-end"
      width={200}
    >
      <Menu.Target>
        <Flex className={styles.sortMenuTarget} aria-label={ariaLabel}>
          <Text variant="subtitle" c="var(--content-primary)">
            {t(activeOption.labelKey)}
          </Text>
          <IconChevronDown
            width={16}
            height={16}
            fill="var(--content-secondary)"
            style={{ transform: opened ? 'rotate(180deg)' : 'none' }}
          />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown>
        {options.map(option => {
          const isActive = option.value === activeValue
          return (
            <Menu.Item
              key={option.value}
              className={styles.sortMenuItem}
              onClick={() => onChange(option.value)}
            >
              <Flex align="center" justify="space-between" w="100%">
                <Text variant="body" fz={14} c="var(--content-primary)">
                  {t(option.labelKey)}
                </Text>
                <IconCheckmark
                  width={20}
                  className={isActive ? styles.sortMenuItemCheckActive : styles.sortMenuItemCheck}
                />
              </Flex>
            </Menu.Item>
          )
        })}
      </Menu.Dropdown>
    </Menu>
  )
}
